
      var $parcel$global = globalThis;
    'use strict';
var $6fd5c554c2e379fb$exports = {};
'use strict';
var $e5245653e95b5e26$exports = {};
'use strict';
$e5245653e95b5e26$exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};


// Detect IE8's incomplete defineProperty implementation
$6fd5c554c2e379fb$exports = !$e5245653e95b5e26$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] !== 7;
});


var $109566f5adb6d9d6$exports = {};
'use strict';
var $e1de7a63adb0169d$exports = {};
'use strict';
var $98d93515e0e907f8$exports = {};
'use strict';
var $2cc708c704b2ff0e$exports = {};
'use strict';

$2cc708c704b2ff0e$exports = !$e5245653e95b5e26$exports(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != 'function' || test.hasOwnProperty('prototype');
});


var $98d93515e0e907f8$var$FunctionPrototype = Function.prototype;
var $98d93515e0e907f8$var$call = $98d93515e0e907f8$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
var $98d93515e0e907f8$var$uncurryThisWithBind = $2cc708c704b2ff0e$exports && $98d93515e0e907f8$var$FunctionPrototype.bind.bind($98d93515e0e907f8$var$call, $98d93515e0e907f8$var$call);
$98d93515e0e907f8$exports = $2cc708c704b2ff0e$exports ? $98d93515e0e907f8$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $98d93515e0e907f8$var$call.apply(fn, arguments);
    };
};



var $dbfbedf4ea4a6d09$exports = {};
'use strict';
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var $dbfbedf4ea4a6d09$var$documentAll = typeof document == 'object' && document.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
$dbfbedf4ea4a6d09$exports = typeof $dbfbedf4ea4a6d09$var$documentAll == 'undefined' && $dbfbedf4ea4a6d09$var$documentAll !== undefined ? function(argument) {
    return typeof argument == 'function' || argument === $dbfbedf4ea4a6d09$var$documentAll;
} : function(argument) {
    return typeof argument == 'function';
};


var $8c7b2987ef924463$exports = {};
'use strict';

var $3ebfe248d7ac25da$exports = {};
'use strict';
var $7f036479c1713728$exports = {};
'use strict';
var $ccc8663ba03e6e7d$exports = {};
'use strict';
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
$ccc8663ba03e6e7d$exports = function(it) {
    return it === null || it === undefined;
};


var $7f036479c1713728$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
$7f036479c1713728$exports = function(it) {
    if ($ccc8663ba03e6e7d$exports(it)) throw new $7f036479c1713728$var$$TypeError("Can't call method on " + it);
    return it;
};


var $3ebfe248d7ac25da$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
$3ebfe248d7ac25da$exports = function(argument) {
    return $3ebfe248d7ac25da$var$$Object($7f036479c1713728$exports(argument));
};


var $8c7b2987ef924463$var$hasOwnProperty = $98d93515e0e907f8$exports({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
$8c7b2987ef924463$exports = Object.hasOwn || function hasOwn(it, key) {
    return $8c7b2987ef924463$var$hasOwnProperty($3ebfe248d7ac25da$exports(it), key);
};



var $6e0cb3e021e793ab$exports = {};
'use strict';


var $6e0cb3e021e793ab$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $6e0cb3e021e793ab$var$getDescriptor = $6fd5c554c2e379fb$exports && Object.getOwnPropertyDescriptor;
var $6e0cb3e021e793ab$var$EXISTS = $8c7b2987ef924463$exports($6e0cb3e021e793ab$var$FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var $6e0cb3e021e793ab$var$PROPER = $6e0cb3e021e793ab$var$EXISTS && (function something() {}).name === 'something';
var $6e0cb3e021e793ab$var$CONFIGURABLE = $6e0cb3e021e793ab$var$EXISTS && (!$6fd5c554c2e379fb$exports || $6fd5c554c2e379fb$exports && $6e0cb3e021e793ab$var$getDescriptor($6e0cb3e021e793ab$var$FunctionPrototype, 'name').configurable);
$6e0cb3e021e793ab$exports = {
    EXISTS: $6e0cb3e021e793ab$var$EXISTS,
    PROPER: $6e0cb3e021e793ab$var$PROPER,
    CONFIGURABLE: $6e0cb3e021e793ab$var$CONFIGURABLE
};


var $e1de7a63adb0169d$require$CONFIGURABLE_FUNCTION_NAME = $6e0cb3e021e793ab$exports.CONFIGURABLE;
var $220a883c3547bbdc$exports = {};
'use strict';


var $88c88e096611463f$exports = {};
'use strict';
var $c1c6a96a31bbfd4c$exports = {};
'use strict';
$c1c6a96a31bbfd4c$exports = false;


var $348e6c47a332b0e2$exports = {};
'use strict';
var $348e6c47a332b0e2$var$check = function(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
$348e6c47a332b0e2$exports = // eslint-disable-next-line es/no-global-this -- safe
$348e6c47a332b0e2$var$check(typeof globalThis == 'object' && globalThis) || $348e6c47a332b0e2$var$check(typeof window == 'object' && window) || // eslint-disable-next-line no-restricted-globals -- safe
$348e6c47a332b0e2$var$check(typeof self == 'object' && self) || $348e6c47a332b0e2$var$check(typeof $parcel$global == 'object' && $parcel$global) || $348e6c47a332b0e2$var$check(typeof $348e6c47a332b0e2$exports == 'object' && $348e6c47a332b0e2$exports) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function('return this')();


var $89acf2497e4c2cee$exports = {};
'use strict';

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $89acf2497e4c2cee$var$defineProperty = Object.defineProperty;
$89acf2497e4c2cee$exports = function(key, value) {
    try {
        $89acf2497e4c2cee$var$defineProperty($348e6c47a332b0e2$exports, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $348e6c47a332b0e2$exports[key] = value;
    }
    return value;
};


var $88c88e096611463f$var$SHARED = '__core-js_shared__';
var $88c88e096611463f$var$store = $88c88e096611463f$exports = $348e6c47a332b0e2$exports[$88c88e096611463f$var$SHARED] || $89acf2497e4c2cee$exports($88c88e096611463f$var$SHARED, {});
($88c88e096611463f$var$store.versions || ($88c88e096611463f$var$store.versions = [])).push({
    version: '3.47.0',
    mode: $c1c6a96a31bbfd4c$exports ? 'pure' : 'global',
    copyright: "\xa9 2014-2025 Denis Pushkarev (zloirock.ru), 2025 CoreJS Company (core-js.io)",
    license: 'https://github.com/zloirock/core-js/blob/v3.47.0/LICENSE',
    source: 'https://github.com/zloirock/core-js'
});


var $220a883c3547bbdc$var$functionToString = $98d93515e0e907f8$exports(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$dbfbedf4ea4a6d09$exports($88c88e096611463f$exports.inspectSource)) $88c88e096611463f$exports.inspectSource = function(it) {
    return $220a883c3547bbdc$var$functionToString(it);
};
$220a883c3547bbdc$exports = $88c88e096611463f$exports.inspectSource;


var $f948694c7a822591$exports = {};
'use strict';
var $85df3d0cd7aa6e71$exports = {};
'use strict';


var $85df3d0cd7aa6e71$var$WeakMap = $348e6c47a332b0e2$exports.WeakMap;
$85df3d0cd7aa6e71$exports = $dbfbedf4ea4a6d09$exports($85df3d0cd7aa6e71$var$WeakMap) && /native code/.test(String($85df3d0cd7aa6e71$var$WeakMap));



var $8c806c3c758c8b3d$exports = {};
'use strict';

$8c806c3c758c8b3d$exports = function(it) {
    return typeof it == 'object' ? it !== null : $dbfbedf4ea4a6d09$exports(it);
};


var $eb0a55d196981480$exports = {};
'use strict';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $8c07b79b91d249fa$export$2d1720544b23b823;
'use strict';

var $25d31ffd8582a715$exports = {};
'use strict';


var $8f4cb3cc8c4f2470$exports = {};
'use strict';


var $8f4cb3cc8c4f2470$var$document = $348e6c47a332b0e2$exports.document;
// typeof document.createElement is 'object' in old IE
var $8f4cb3cc8c4f2470$var$EXISTS = $8c806c3c758c8b3d$exports($8f4cb3cc8c4f2470$var$document) && $8c806c3c758c8b3d$exports($8f4cb3cc8c4f2470$var$document.createElement);
$8f4cb3cc8c4f2470$exports = function(it) {
    return $8f4cb3cc8c4f2470$var$EXISTS ? $8f4cb3cc8c4f2470$var$document.createElement(it) : {};
};


// Thanks to IE8 for its funny defineProperty
$25d31ffd8582a715$exports = !$6fd5c554c2e379fb$exports && !$e5245653e95b5e26$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($8f4cb3cc8c4f2470$exports('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a !== 7;
});


var $2990091dd1a94608$exports = {};
'use strict';


// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
$2990091dd1a94608$exports = $6fd5c554c2e379fb$exports && $e5245653e95b5e26$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, 'prototype', {
        value: 42,
        writable: false
    }).prototype !== 42;
});


var $1c0d8d4d564036ad$exports = {};
'use strict';

var $1c0d8d4d564036ad$var$$String = String;
var $1c0d8d4d564036ad$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
$1c0d8d4d564036ad$exports = function(argument) {
    if ($8c806c3c758c8b3d$exports(argument)) return argument;
    throw new $1c0d8d4d564036ad$var$$TypeError($1c0d8d4d564036ad$var$$String(argument) + ' is not an object');
};


var $fba8d781bbdf6d63$exports = {};
'use strict';
var $95f2b66e89d69992$exports = {};
'use strict';
var $8fe6272fd87552a5$exports = {};
'use strict';

var $8fe6272fd87552a5$var$call = Function.prototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
$8fe6272fd87552a5$exports = $2cc708c704b2ff0e$exports ? $8fe6272fd87552a5$var$call.bind($8fe6272fd87552a5$var$call) : function() {
    return $8fe6272fd87552a5$var$call.apply($8fe6272fd87552a5$var$call, arguments);
};



var $61fd48bf6e1fb74e$exports = {};
'use strict';
var $7624a7bed62f9402$exports = {};
'use strict';


var $7624a7bed62f9402$var$aFunction = function(argument) {
    return $dbfbedf4ea4a6d09$exports(argument) ? argument : undefined;
};
$7624a7bed62f9402$exports = function(namespace, method) {
    return arguments.length < 2 ? $7624a7bed62f9402$var$aFunction($348e6c47a332b0e2$exports[namespace]) : $348e6c47a332b0e2$exports[namespace] && $348e6c47a332b0e2$exports[namespace][method];
};



var $670623a905b5aac1$exports = {};
'use strict';

$670623a905b5aac1$exports = $98d93515e0e907f8$exports({}.isPrototypeOf);


var $3adf04aa4a2cf6f3$exports = {};
'use strict';
var $30912c01badd05c6$exports = {};
'use strict';
var $e231ecffbc180e2c$exports = {};
'use strict';

var $60cc6c89a84ad112$exports = {};
'use strict';

var $60cc6c89a84ad112$var$navigator = $348e6c47a332b0e2$exports.navigator;
var $60cc6c89a84ad112$var$userAgent = $60cc6c89a84ad112$var$navigator && $60cc6c89a84ad112$var$navigator.userAgent;
$60cc6c89a84ad112$exports = $60cc6c89a84ad112$var$userAgent ? String($60cc6c89a84ad112$var$userAgent) : '';


var $e231ecffbc180e2c$var$process = $348e6c47a332b0e2$exports.process;
var $e231ecffbc180e2c$var$Deno = $348e6c47a332b0e2$exports.Deno;
var $e231ecffbc180e2c$var$versions = $e231ecffbc180e2c$var$process && $e231ecffbc180e2c$var$process.versions || $e231ecffbc180e2c$var$Deno && $e231ecffbc180e2c$var$Deno.version;
var $e231ecffbc180e2c$var$v8 = $e231ecffbc180e2c$var$versions && $e231ecffbc180e2c$var$versions.v8;
var $e231ecffbc180e2c$var$match, $e231ecffbc180e2c$var$version;
if ($e231ecffbc180e2c$var$v8) {
    $e231ecffbc180e2c$var$match = $e231ecffbc180e2c$var$v8.split('.');
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $e231ecffbc180e2c$var$version = $e231ecffbc180e2c$var$match[0] > 0 && $e231ecffbc180e2c$var$match[0] < 4 ? 1 : +($e231ecffbc180e2c$var$match[0] + $e231ecffbc180e2c$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$e231ecffbc180e2c$var$version && $60cc6c89a84ad112$exports) {
    $e231ecffbc180e2c$var$match = $60cc6c89a84ad112$exports.match(/Edge\/(\d+)/);
    if (!$e231ecffbc180e2c$var$match || $e231ecffbc180e2c$var$match[1] >= 74) {
        $e231ecffbc180e2c$var$match = $60cc6c89a84ad112$exports.match(/Chrome\/(\d+)/);
        if ($e231ecffbc180e2c$var$match) $e231ecffbc180e2c$var$version = +$e231ecffbc180e2c$var$match[1];
    }
}
$e231ecffbc180e2c$exports = $e231ecffbc180e2c$var$version;




var $30912c01badd05c6$var$$String = $348e6c47a332b0e2$exports.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
$30912c01badd05c6$exports = !!Object.getOwnPropertySymbols && !$e5245653e95b5e26$exports(function() {
    var symbol = Symbol('symbol detection');
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$30912c01badd05c6$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $e231ecffbc180e2c$exports && $e231ecffbc180e2c$exports < 41;
});


$3adf04aa4a2cf6f3$exports = $30912c01badd05c6$exports && !Symbol.sham && typeof Symbol.iterator == 'symbol';


var $61fd48bf6e1fb74e$var$$Object = Object;
$61fd48bf6e1fb74e$exports = $3adf04aa4a2cf6f3$exports ? function(it) {
    return typeof it == 'symbol';
} : function(it) {
    var $Symbol = $7624a7bed62f9402$exports('Symbol');
    return $dbfbedf4ea4a6d09$exports($Symbol) && $670623a905b5aac1$exports($Symbol.prototype, $61fd48bf6e1fb74e$var$$Object(it));
};


var $911494874e273ede$exports = {};
'use strict';
var $4b16eff6617840b7$exports = {};
'use strict';

var $68e4b01fef6306b4$exports = {};
'use strict';
var $68e4b01fef6306b4$var$$String = String;
$68e4b01fef6306b4$exports = function(argument) {
    try {
        return $68e4b01fef6306b4$var$$String(argument);
    } catch (error) {
        return 'Object';
    }
};


var $4b16eff6617840b7$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
$4b16eff6617840b7$exports = function(argument) {
    if ($dbfbedf4ea4a6d09$exports(argument)) return argument;
    throw new $4b16eff6617840b7$var$$TypeError($68e4b01fef6306b4$exports(argument) + ' is not a function');
};



// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
$911494874e273ede$exports = function(V, P) {
    var func = V[P];
    return $ccc8663ba03e6e7d$exports(func) ? undefined : $4b16eff6617840b7$exports(func);
};


var $51e96ea06a2e4a70$exports = {};
'use strict';



var $51e96ea06a2e4a70$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
$51e96ea06a2e4a70$exports = function(input, pref) {
    var fn, val;
    if (pref === 'string' && $dbfbedf4ea4a6d09$exports(fn = input.toString) && !$8c806c3c758c8b3d$exports(val = $8fe6272fd87552a5$exports(fn, input))) return val;
    if ($dbfbedf4ea4a6d09$exports(fn = input.valueOf) && !$8c806c3c758c8b3d$exports(val = $8fe6272fd87552a5$exports(fn, input))) return val;
    if (pref !== 'string' && $dbfbedf4ea4a6d09$exports(fn = input.toString) && !$8c806c3c758c8b3d$exports(val = $8fe6272fd87552a5$exports(fn, input))) return val;
    throw new $51e96ea06a2e4a70$var$$TypeError("Can't convert object to primitive value");
};


var $6a51cc9b46f5c2ea$exports = {};
'use strict';

var $b6a78adbb0f0fe8f$exports = {};
'use strict';

$b6a78adbb0f0fe8f$exports = function(key, value) {
    return $88c88e096611463f$exports[key] || ($88c88e096611463f$exports[key] = value || {});
};



var $c940efa3cb628fb3$exports = {};
'use strict';

var $c940efa3cb628fb3$var$id = 0;
var $c940efa3cb628fb3$var$postfix = Math.random();
var $c940efa3cb628fb3$var$toString = $98d93515e0e907f8$exports(1.1.toString);
$c940efa3cb628fb3$exports = function(key) {
    return 'Symbol(' + (key === undefined ? '' : key) + ')_' + $c940efa3cb628fb3$var$toString(++$c940efa3cb628fb3$var$id + $c940efa3cb628fb3$var$postfix, 36);
};




var $6a51cc9b46f5c2ea$var$Symbol = $348e6c47a332b0e2$exports.Symbol;
var $6a51cc9b46f5c2ea$var$WellKnownSymbolsStore = $b6a78adbb0f0fe8f$exports('wks');
var $6a51cc9b46f5c2ea$var$createWellKnownSymbol = $3adf04aa4a2cf6f3$exports ? $6a51cc9b46f5c2ea$var$Symbol['for'] || $6a51cc9b46f5c2ea$var$Symbol : $6a51cc9b46f5c2ea$var$Symbol && $6a51cc9b46f5c2ea$var$Symbol.withoutSetter || $c940efa3cb628fb3$exports;
$6a51cc9b46f5c2ea$exports = function(name) {
    if (!$8c7b2987ef924463$exports($6a51cc9b46f5c2ea$var$WellKnownSymbolsStore, name)) $6a51cc9b46f5c2ea$var$WellKnownSymbolsStore[name] = $30912c01badd05c6$exports && $8c7b2987ef924463$exports($6a51cc9b46f5c2ea$var$Symbol, name) ? $6a51cc9b46f5c2ea$var$Symbol[name] : $6a51cc9b46f5c2ea$var$createWellKnownSymbol('Symbol.' + name);
    return $6a51cc9b46f5c2ea$var$WellKnownSymbolsStore[name];
};


var $95f2b66e89d69992$var$$TypeError = TypeError;
var $95f2b66e89d69992$var$TO_PRIMITIVE = $6a51cc9b46f5c2ea$exports('toPrimitive');
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
$95f2b66e89d69992$exports = function(input, pref) {
    if (!$8c806c3c758c8b3d$exports(input) || $61fd48bf6e1fb74e$exports(input)) return input;
    var exoticToPrim = $911494874e273ede$exports(input, $95f2b66e89d69992$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = 'default';
        result = $8fe6272fd87552a5$exports(exoticToPrim, input, pref);
        if (!$8c806c3c758c8b3d$exports(result) || $61fd48bf6e1fb74e$exports(result)) return result;
        throw new $95f2b66e89d69992$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = 'number';
    return $51e96ea06a2e4a70$exports(input, pref);
};



// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
$fba8d781bbdf6d63$exports = function(argument) {
    var key = $95f2b66e89d69992$exports(argument, 'string');
    return $61fd48bf6e1fb74e$exports(key) ? key : key + '';
};


var $8c07b79b91d249fa$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $8c07b79b91d249fa$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $8c07b79b91d249fa$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $8c07b79b91d249fa$var$ENUMERABLE = 'enumerable';
var $8c07b79b91d249fa$var$CONFIGURABLE = 'configurable';
var $8c07b79b91d249fa$var$WRITABLE = 'writable';
$8c07b79b91d249fa$export$2d1720544b23b823 = $6fd5c554c2e379fb$exports ? $2990091dd1a94608$exports ? function defineProperty(O, P, Attributes) {
    $1c0d8d4d564036ad$exports(O);
    P = $fba8d781bbdf6d63$exports(P);
    $1c0d8d4d564036ad$exports(Attributes);
    if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && $8c07b79b91d249fa$var$WRITABLE in Attributes && !Attributes[$8c07b79b91d249fa$var$WRITABLE]) {
        var current = $8c07b79b91d249fa$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$8c07b79b91d249fa$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $8c07b79b91d249fa$var$CONFIGURABLE in Attributes ? Attributes[$8c07b79b91d249fa$var$CONFIGURABLE] : current[$8c07b79b91d249fa$var$CONFIGURABLE],
                enumerable: $8c07b79b91d249fa$var$ENUMERABLE in Attributes ? Attributes[$8c07b79b91d249fa$var$ENUMERABLE] : current[$8c07b79b91d249fa$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $8c07b79b91d249fa$var$$defineProperty(O, P, Attributes);
} : $8c07b79b91d249fa$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $1c0d8d4d564036ad$exports(O);
    P = $fba8d781bbdf6d63$exports(P);
    $1c0d8d4d564036ad$exports(Attributes);
    if ($25d31ffd8582a715$exports) try {
        return $8c07b79b91d249fa$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ('get' in Attributes || 'set' in Attributes) throw new $8c07b79b91d249fa$var$$TypeError('Accessors not supported');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};


var $5bc00574d29a028f$exports = {};
'use strict';
$5bc00574d29a028f$exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


$eb0a55d196981480$exports = $6fd5c554c2e379fb$exports ? function(object, key, value) {
    return $8c07b79b91d249fa$export$2d1720544b23b823(object, key, $5bc00574d29a028f$exports(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};




var $1181d207505bafbd$exports = {};
'use strict';


var $1181d207505bafbd$var$keys = $b6a78adbb0f0fe8f$exports('keys');
$1181d207505bafbd$exports = function(key) {
    return $1181d207505bafbd$var$keys[key] || ($1181d207505bafbd$var$keys[key] = $c940efa3cb628fb3$exports(key));
};


var $4596fff8ae7ced2f$exports = {};
'use strict';
$4596fff8ae7ced2f$exports = {};


var $f948694c7a822591$var$OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var $f948694c7a822591$var$TypeError = $348e6c47a332b0e2$exports.TypeError;
var $f948694c7a822591$var$WeakMap = $348e6c47a332b0e2$exports.WeakMap;
var $f948694c7a822591$var$set, $f948694c7a822591$var$get, $f948694c7a822591$var$has;
var $f948694c7a822591$var$enforce = function(it) {
    return $f948694c7a822591$var$has(it) ? $f948694c7a822591$var$get(it) : $f948694c7a822591$var$set(it, {});
};
var $f948694c7a822591$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$8c806c3c758c8b3d$exports(it) || (state = $f948694c7a822591$var$get(it)).type !== TYPE) throw new $f948694c7a822591$var$TypeError('Incompatible receiver, ' + TYPE + ' required');
        return state;
    };
};
if ($85df3d0cd7aa6e71$exports || $88c88e096611463f$exports.state) {
    var $f948694c7a822591$var$store = $88c88e096611463f$exports.state || ($88c88e096611463f$exports.state = new $f948694c7a822591$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $f948694c7a822591$var$store.get = $f948694c7a822591$var$store.get;
    $f948694c7a822591$var$store.has = $f948694c7a822591$var$store.has;
    $f948694c7a822591$var$store.set = $f948694c7a822591$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $f948694c7a822591$var$set = function(it, metadata) {
        if ($f948694c7a822591$var$store.has(it)) throw new $f948694c7a822591$var$TypeError($f948694c7a822591$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $f948694c7a822591$var$store.set(it, metadata);
        return metadata;
    };
    $f948694c7a822591$var$get = function(it) {
        return $f948694c7a822591$var$store.get(it) || {};
    };
    $f948694c7a822591$var$has = function(it) {
        return $f948694c7a822591$var$store.has(it);
    };
} else {
    var $f948694c7a822591$var$STATE = $1181d207505bafbd$exports('state');
    $4596fff8ae7ced2f$exports[$f948694c7a822591$var$STATE] = true;
    $f948694c7a822591$var$set = function(it, metadata) {
        if ($8c7b2987ef924463$exports(it, $f948694c7a822591$var$STATE)) throw new $f948694c7a822591$var$TypeError($f948694c7a822591$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $eb0a55d196981480$exports(it, $f948694c7a822591$var$STATE, metadata);
        return metadata;
    };
    $f948694c7a822591$var$get = function(it) {
        return $8c7b2987ef924463$exports(it, $f948694c7a822591$var$STATE) ? it[$f948694c7a822591$var$STATE] : {};
    };
    $f948694c7a822591$var$has = function(it) {
        return $8c7b2987ef924463$exports(it, $f948694c7a822591$var$STATE);
    };
}
$f948694c7a822591$exports = {
    set: $f948694c7a822591$var$set,
    get: $f948694c7a822591$var$get,
    has: $f948694c7a822591$var$has,
    enforce: $f948694c7a822591$var$enforce,
    getterFor: $f948694c7a822591$var$getterFor
};


var $e1de7a63adb0169d$var$enforceInternalState = $f948694c7a822591$exports.enforce;
var $e1de7a63adb0169d$var$getInternalState = $f948694c7a822591$exports.get;
var $e1de7a63adb0169d$var$$String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $e1de7a63adb0169d$var$defineProperty = Object.defineProperty;
var $e1de7a63adb0169d$var$stringSlice = $98d93515e0e907f8$exports(''.slice);
var $e1de7a63adb0169d$var$replace = $98d93515e0e907f8$exports(''.replace);
var $e1de7a63adb0169d$var$join = $98d93515e0e907f8$exports([].join);
var $e1de7a63adb0169d$var$CONFIGURABLE_LENGTH = $6fd5c554c2e379fb$exports && !$e5245653e95b5e26$exports(function() {
    return $e1de7a63adb0169d$var$defineProperty(function() {}, 'length', {
        value: 8
    }).length !== 8;
});
var $e1de7a63adb0169d$var$TEMPLATE = String(String).split('String');
var $e1de7a63adb0169d$var$makeBuiltIn = $e1de7a63adb0169d$exports = function(value, name, options) {
    if ($e1de7a63adb0169d$var$stringSlice($e1de7a63adb0169d$var$$String(name), 0, 7) === 'Symbol(') name = '[' + $e1de7a63adb0169d$var$replace($e1de7a63adb0169d$var$$String(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
    if (options && options.getter) name = 'get ' + name;
    if (options && options.setter) name = 'set ' + name;
    if (!$8c7b2987ef924463$exports(value, 'name') || $e1de7a63adb0169d$require$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($6fd5c554c2e379fb$exports) $e1de7a63adb0169d$var$defineProperty(value, 'name', {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($e1de7a63adb0169d$var$CONFIGURABLE_LENGTH && options && $8c7b2987ef924463$exports(options, 'arity') && value.length !== options.arity) $e1de7a63adb0169d$var$defineProperty(value, 'length', {
        value: options.arity
    });
    try {
        if (options && $8c7b2987ef924463$exports(options, 'constructor') && options.constructor) {
            if ($6fd5c554c2e379fb$exports) $e1de7a63adb0169d$var$defineProperty(value, 'prototype', {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $e1de7a63adb0169d$var$enforceInternalState(value);
    if (!$8c7b2987ef924463$exports(state, 'source')) state.source = $e1de7a63adb0169d$var$join($e1de7a63adb0169d$var$TEMPLATE, typeof name == 'string' ? name : '');
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $e1de7a63adb0169d$var$makeBuiltIn(function toString() {
    return $dbfbedf4ea4a6d09$exports(this) && $e1de7a63adb0169d$var$getInternalState(this).source || $220a883c3547bbdc$exports(this);
}, 'toString');



$109566f5adb6d9d6$exports = function(target, name, descriptor) {
    if (descriptor.get) $e1de7a63adb0169d$exports(descriptor.get, name, {
        getter: true
    });
    if (descriptor.set) $e1de7a63adb0169d$exports(descriptor.set, name, {
        setter: true
    });
    return $8c07b79b91d249fa$export$2d1720544b23b823(target, name, descriptor);
};


var $35050d350f5d4941$exports = {};
'use strict';


// babel-minify and Closure Compiler transpiles RegExp('.', 'd') -> /./d and it causes SyntaxError
var $35050d350f5d4941$var$RegExp = $348e6c47a332b0e2$exports.RegExp;
var $35050d350f5d4941$var$FLAGS_GETTER_IS_CORRECT = !$e5245653e95b5e26$exports(function() {
    var INDICES_SUPPORT = true;
    try {
        $35050d350f5d4941$var$RegExp('.', 'd');
    } catch (error) {
        INDICES_SUPPORT = false;
    }
    var O = {};
    // modern V8 bug
    var calls = '';
    var expected = INDICES_SUPPORT ? 'dgimsy' : 'gimsy';
    var addGetter = function(key, chr) {
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        Object.defineProperty(O, key, {
            get: function() {
                calls += chr;
                return true;
            }
        });
    };
    var pairs = {
        dotAll: 's',
        global: 'g',
        ignoreCase: 'i',
        multiline: 'm',
        sticky: 'y'
    };
    if (INDICES_SUPPORT) pairs.hasIndices = 'd';
    for(var key in pairs)addGetter(key, pairs[key]);
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    var result = Object.getOwnPropertyDescriptor($35050d350f5d4941$var$RegExp.prototype, 'flags').get.call(O);
    return result !== expected || calls !== expected;
});
$35050d350f5d4941$exports = {
    correct: $35050d350f5d4941$var$FLAGS_GETTER_IS_CORRECT
};


var $054b1453a7ed2bc8$exports = {};
'use strict';

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
$054b1453a7ed2bc8$exports = function() {
    var that = $1c0d8d4d564036ad$exports(this);
    var result = '';
    if (that.hasIndices) result += 'd';
    if (that.global) result += 'g';
    if (that.ignoreCase) result += 'i';
    if (that.multiline) result += 'm';
    if (that.dotAll) result += 's';
    if (that.unicode) result += 'u';
    if (that.unicodeSets) result += 'v';
    if (that.sticky) result += 'y';
    return result;
};


// `RegExp.prototype.flags` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
if ($6fd5c554c2e379fb$exports && !$35050d350f5d4941$exports.correct) {
    $109566f5adb6d9d6$exports(RegExp.prototype, 'flags', {
        configurable: true,
        get: $054b1453a7ed2bc8$exports
    });
    $35050d350f5d4941$exports.correct = true;
}


'use strict';


var $d4af3caa498828ab$exports = {};
'use strict';
var $ea5d2f0ff91a9d9b$exports = {};
'use strict';
// eslint-disable-next-line es/no-typed-arrays -- safe
$ea5d2f0ff91a9d9b$exports = typeof ArrayBuffer != 'undefined' && typeof DataView != 'undefined';







var $e23d73603656e395$exports = {};
'use strict';
var $7508283fb5a975ba$exports = {};
'use strict';

var $7508283fb5a975ba$var$TO_STRING_TAG = $6a51cc9b46f5c2ea$exports('toStringTag');
var $7508283fb5a975ba$var$test = {};
// eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
$7508283fb5a975ba$var$test[$7508283fb5a975ba$var$TO_STRING_TAG] = 'z';
$7508283fb5a975ba$exports = String($7508283fb5a975ba$var$test) === '[object z]';



var $182d4f3988cca675$exports = {};
'use strict';

var $182d4f3988cca675$var$toString = $98d93515e0e907f8$exports({}.toString);
var $182d4f3988cca675$var$stringSlice = $98d93515e0e907f8$exports(''.slice);
$182d4f3988cca675$exports = function(it) {
    return $182d4f3988cca675$var$stringSlice($182d4f3988cca675$var$toString(it), 8, -1);
};



var $e23d73603656e395$var$TO_STRING_TAG = $6a51cc9b46f5c2ea$exports('toStringTag');
var $e23d73603656e395$var$$Object = Object;
// ES3 wrong here
var $e23d73603656e395$var$CORRECT_ARGUMENTS = $182d4f3988cca675$exports(function() {
    return arguments;
}()) === 'Arguments';
// fallback for IE11 Script Access Denied error
var $e23d73603656e395$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
$e23d73603656e395$exports = $7508283fb5a975ba$exports ? $182d4f3988cca675$exports : function(it) {
    var O, tag, result;
    return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (tag = $e23d73603656e395$var$tryGet(O = $e23d73603656e395$var$$Object(it), $e23d73603656e395$var$TO_STRING_TAG)) == 'string' ? tag : $e23d73603656e395$var$CORRECT_ARGUMENTS ? $182d4f3988cca675$exports(O) : (result = $182d4f3988cca675$exports(O)) === 'Object' && $dbfbedf4ea4a6d09$exports(O.callee) ? 'Arguments' : result;
};




var $3fdb65a5c6da057e$exports = {};
'use strict';




$3fdb65a5c6da057e$exports = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($dbfbedf4ea4a6d09$exports(value)) $e1de7a63adb0169d$exports(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $89acf2497e4c2cee$exports(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $8c07b79b91d249fa$export$2d1720544b23b823(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};




var $fdff676cafa10f40$exports = {};
'use strict';




var $ff6cf53f355617cd$exports = {};
'use strict';

$ff6cf53f355617cd$exports = !$e5245653e95b5e26$exports(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});


var $fdff676cafa10f40$var$IE_PROTO = $1181d207505bafbd$exports('IE_PROTO');
var $fdff676cafa10f40$var$$Object = Object;
var $fdff676cafa10f40$var$ObjectPrototype = $fdff676cafa10f40$var$$Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
$fdff676cafa10f40$exports = $ff6cf53f355617cd$exports ? $fdff676cafa10f40$var$$Object.getPrototypeOf : function(O) {
    var object = $3ebfe248d7ac25da$exports(O);
    if ($8c7b2987ef924463$exports(object, $fdff676cafa10f40$var$IE_PROTO)) return object[$fdff676cafa10f40$var$IE_PROTO];
    var constructor = object.constructor;
    if ($dbfbedf4ea4a6d09$exports(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $fdff676cafa10f40$var$$Object ? $fdff676cafa10f40$var$ObjectPrototype : null;
};


var $fc103a889d94ccaa$exports = {};
'use strict';
var $38faee58b61d67f0$exports = {};
'use strict';


$38faee58b61d67f0$exports = function(object, key, method) {
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        return $98d93515e0e907f8$exports($4b16eff6617840b7$exports(Object.getOwnPropertyDescriptor(object, key)[method]));
    } catch (error) {}
};




var $c14a66748792a870$exports = {};
'use strict';
var $881db6d7710abd77$exports = {};
'use strict';

$881db6d7710abd77$exports = function(argument) {
    return $8c806c3c758c8b3d$exports(argument) || argument === null;
};


var $c14a66748792a870$var$$String = String;
var $c14a66748792a870$var$$TypeError = TypeError;
$c14a66748792a870$exports = function(argument) {
    if ($881db6d7710abd77$exports(argument)) return argument;
    throw new $c14a66748792a870$var$$TypeError("Can't set " + $c14a66748792a870$var$$String(argument) + ' as a prototype');
};


// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
$fc103a889d94ccaa$exports = Object.setPrototypeOf || ('__proto__' in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        setter = $38faee58b61d67f0$exports(Object.prototype, '__proto__', 'set');
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $7f036479c1713728$exports(O);
        $c14a66748792a870$exports(proto);
        if (!$8c806c3c758c8b3d$exports(O)) return O;
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);





var $d4af3caa498828ab$var$enforceInternalState = $f948694c7a822591$exports.enforce;
var $d4af3caa498828ab$var$getInternalState = $f948694c7a822591$exports.get;
var $d4af3caa498828ab$var$Int8Array = $348e6c47a332b0e2$exports.Int8Array;
var $d4af3caa498828ab$var$Int8ArrayPrototype = $d4af3caa498828ab$var$Int8Array && $d4af3caa498828ab$var$Int8Array.prototype;
var $d4af3caa498828ab$var$Uint8ClampedArray = $348e6c47a332b0e2$exports.Uint8ClampedArray;
var $d4af3caa498828ab$var$Uint8ClampedArrayPrototype = $d4af3caa498828ab$var$Uint8ClampedArray && $d4af3caa498828ab$var$Uint8ClampedArray.prototype;
var $d4af3caa498828ab$var$TypedArray = $d4af3caa498828ab$var$Int8Array && $fdff676cafa10f40$exports($d4af3caa498828ab$var$Int8Array);
var $d4af3caa498828ab$var$TypedArrayPrototype = $d4af3caa498828ab$var$Int8ArrayPrototype && $fdff676cafa10f40$exports($d4af3caa498828ab$var$Int8ArrayPrototype);
var $d4af3caa498828ab$var$ObjectPrototype = Object.prototype;
var $d4af3caa498828ab$var$TypeError = $348e6c47a332b0e2$exports.TypeError;
var $d4af3caa498828ab$var$TO_STRING_TAG = $6a51cc9b46f5c2ea$exports('toStringTag');
var $d4af3caa498828ab$var$TYPED_ARRAY_TAG = $c940efa3cb628fb3$exports('TYPED_ARRAY_TAG');
var $d4af3caa498828ab$var$TYPED_ARRAY_CONSTRUCTOR = 'TypedArrayConstructor';
// Fixing native typed arrays in Opera Presto crashes the browser, see #595
var $d4af3caa498828ab$var$NATIVE_ARRAY_BUFFER_VIEWS = $ea5d2f0ff91a9d9b$exports && !!$fc103a889d94ccaa$exports && $e23d73603656e395$exports($348e6c47a332b0e2$exports.opera) !== 'Opera';
var $d4af3caa498828ab$var$TYPED_ARRAY_TAG_REQUIRED = false;
var $d4af3caa498828ab$var$NAME, $d4af3caa498828ab$var$Constructor, $d4af3caa498828ab$var$Prototype;
var $d4af3caa498828ab$var$TypedArrayConstructorsList = {
    Int8Array: 1,
    Uint8Array: 1,
    Uint8ClampedArray: 1,
    Int16Array: 2,
    Uint16Array: 2,
    Int32Array: 4,
    Uint32Array: 4,
    Float32Array: 4,
    Float64Array: 8
};
var $d4af3caa498828ab$var$BigIntArrayConstructorsList = {
    BigInt64Array: 8,
    BigUint64Array: 8
};
var $d4af3caa498828ab$var$isView = function isView(it) {
    if (!$8c806c3c758c8b3d$exports(it)) return false;
    var klass = $e23d73603656e395$exports(it);
    return klass === 'DataView' || $8c7b2987ef924463$exports($d4af3caa498828ab$var$TypedArrayConstructorsList, klass) || $8c7b2987ef924463$exports($d4af3caa498828ab$var$BigIntArrayConstructorsList, klass);
};
var $d4af3caa498828ab$var$getTypedArrayConstructor = function(it) {
    var proto = $fdff676cafa10f40$exports(it);
    if (!$8c806c3c758c8b3d$exports(proto)) return;
    var state = $d4af3caa498828ab$var$getInternalState(proto);
    return state && $8c7b2987ef924463$exports(state, $d4af3caa498828ab$var$TYPED_ARRAY_CONSTRUCTOR) ? state[$d4af3caa498828ab$var$TYPED_ARRAY_CONSTRUCTOR] : $d4af3caa498828ab$var$getTypedArrayConstructor(proto);
};
var $d4af3caa498828ab$var$isTypedArray = function(it) {
    if (!$8c806c3c758c8b3d$exports(it)) return false;
    var klass = $e23d73603656e395$exports(it);
    return $8c7b2987ef924463$exports($d4af3caa498828ab$var$TypedArrayConstructorsList, klass) || $8c7b2987ef924463$exports($d4af3caa498828ab$var$BigIntArrayConstructorsList, klass);
};
var $d4af3caa498828ab$var$aTypedArray = function(it) {
    if ($d4af3caa498828ab$var$isTypedArray(it)) return it;
    throw new $d4af3caa498828ab$var$TypeError('Target is not a typed array');
};
var $d4af3caa498828ab$var$aTypedArrayConstructor = function(C) {
    if ($dbfbedf4ea4a6d09$exports(C) && (!$fc103a889d94ccaa$exports || $670623a905b5aac1$exports($d4af3caa498828ab$var$TypedArray, C))) return C;
    throw new $d4af3caa498828ab$var$TypeError($68e4b01fef6306b4$exports(C) + ' is not a typed array constructor');
};
var $d4af3caa498828ab$var$exportTypedArrayMethod = function(KEY, property, forced, options) {
    if (!$6fd5c554c2e379fb$exports) return;
    if (forced) for(var ARRAY in $d4af3caa498828ab$var$TypedArrayConstructorsList){
        var TypedArrayConstructor = $348e6c47a332b0e2$exports[ARRAY];
        if (TypedArrayConstructor && $8c7b2987ef924463$exports(TypedArrayConstructor.prototype, KEY)) try {
            delete TypedArrayConstructor.prototype[KEY];
        } catch (error) {
            // old WebKit bug - some methods are non-configurable
            try {
                TypedArrayConstructor.prototype[KEY] = property;
            } catch (error2) {}
        }
    }
    if (!$d4af3caa498828ab$var$TypedArrayPrototype[KEY] || forced) $3fdb65a5c6da057e$exports($d4af3caa498828ab$var$TypedArrayPrototype, KEY, forced ? property : $d4af3caa498828ab$var$NATIVE_ARRAY_BUFFER_VIEWS && $d4af3caa498828ab$var$Int8ArrayPrototype[KEY] || property, options);
};
var $d4af3caa498828ab$var$exportTypedArrayStaticMethod = function(KEY, property, forced) {
    var ARRAY, TypedArrayConstructor;
    if (!$6fd5c554c2e379fb$exports) return;
    if ($fc103a889d94ccaa$exports) {
        if (forced) for(ARRAY in $d4af3caa498828ab$var$TypedArrayConstructorsList){
            TypedArrayConstructor = $348e6c47a332b0e2$exports[ARRAY];
            if (TypedArrayConstructor && $8c7b2987ef924463$exports(TypedArrayConstructor, KEY)) try {
                delete TypedArrayConstructor[KEY];
            } catch (error) {}
        }
        if (!$d4af3caa498828ab$var$TypedArray[KEY] || forced) // V8 ~ Chrome 49-50 `%TypedArray%` methods are non-writable non-configurable
        try {
            return $3fdb65a5c6da057e$exports($d4af3caa498828ab$var$TypedArray, KEY, forced ? property : $d4af3caa498828ab$var$NATIVE_ARRAY_BUFFER_VIEWS && $d4af3caa498828ab$var$TypedArray[KEY] || property);
        } catch (error) {}
        else return;
    }
    for(ARRAY in $d4af3caa498828ab$var$TypedArrayConstructorsList){
        TypedArrayConstructor = $348e6c47a332b0e2$exports[ARRAY];
        if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) $3fdb65a5c6da057e$exports(TypedArrayConstructor, KEY, property);
    }
};
for($d4af3caa498828ab$var$NAME in $d4af3caa498828ab$var$TypedArrayConstructorsList){
    $d4af3caa498828ab$var$Constructor = $348e6c47a332b0e2$exports[$d4af3caa498828ab$var$NAME];
    $d4af3caa498828ab$var$Prototype = $d4af3caa498828ab$var$Constructor && $d4af3caa498828ab$var$Constructor.prototype;
    if ($d4af3caa498828ab$var$Prototype) $d4af3caa498828ab$var$enforceInternalState($d4af3caa498828ab$var$Prototype)[$d4af3caa498828ab$var$TYPED_ARRAY_CONSTRUCTOR] = $d4af3caa498828ab$var$Constructor;
    else $d4af3caa498828ab$var$NATIVE_ARRAY_BUFFER_VIEWS = false;
}
for($d4af3caa498828ab$var$NAME in $d4af3caa498828ab$var$BigIntArrayConstructorsList){
    $d4af3caa498828ab$var$Constructor = $348e6c47a332b0e2$exports[$d4af3caa498828ab$var$NAME];
    $d4af3caa498828ab$var$Prototype = $d4af3caa498828ab$var$Constructor && $d4af3caa498828ab$var$Constructor.prototype;
    if ($d4af3caa498828ab$var$Prototype) $d4af3caa498828ab$var$enforceInternalState($d4af3caa498828ab$var$Prototype)[$d4af3caa498828ab$var$TYPED_ARRAY_CONSTRUCTOR] = $d4af3caa498828ab$var$Constructor;
}
// WebKit bug - typed arrays constructors prototype is Object.prototype
if (!$d4af3caa498828ab$var$NATIVE_ARRAY_BUFFER_VIEWS || !$dbfbedf4ea4a6d09$exports($d4af3caa498828ab$var$TypedArray) || $d4af3caa498828ab$var$TypedArray === Function.prototype) {
    // eslint-disable-next-line no-shadow -- safe
    $d4af3caa498828ab$var$TypedArray = function TypedArray() {
        throw new $d4af3caa498828ab$var$TypeError('Incorrect invocation');
    };
    if ($d4af3caa498828ab$var$NATIVE_ARRAY_BUFFER_VIEWS) {
        for($d4af3caa498828ab$var$NAME in $d4af3caa498828ab$var$TypedArrayConstructorsList)if ($348e6c47a332b0e2$exports[$d4af3caa498828ab$var$NAME]) $fc103a889d94ccaa$exports($348e6c47a332b0e2$exports[$d4af3caa498828ab$var$NAME], $d4af3caa498828ab$var$TypedArray);
    }
}
if (!$d4af3caa498828ab$var$NATIVE_ARRAY_BUFFER_VIEWS || !$d4af3caa498828ab$var$TypedArrayPrototype || $d4af3caa498828ab$var$TypedArrayPrototype === $d4af3caa498828ab$var$ObjectPrototype) {
    $d4af3caa498828ab$var$TypedArrayPrototype = $d4af3caa498828ab$var$TypedArray.prototype;
    if ($d4af3caa498828ab$var$NATIVE_ARRAY_BUFFER_VIEWS) {
        for($d4af3caa498828ab$var$NAME in $d4af3caa498828ab$var$TypedArrayConstructorsList)if ($348e6c47a332b0e2$exports[$d4af3caa498828ab$var$NAME]) $fc103a889d94ccaa$exports($348e6c47a332b0e2$exports[$d4af3caa498828ab$var$NAME].prototype, $d4af3caa498828ab$var$TypedArrayPrototype);
    }
}
// WebKit bug - one more object in Uint8ClampedArray prototype chain
if ($d4af3caa498828ab$var$NATIVE_ARRAY_BUFFER_VIEWS && $fdff676cafa10f40$exports($d4af3caa498828ab$var$Uint8ClampedArrayPrototype) !== $d4af3caa498828ab$var$TypedArrayPrototype) $fc103a889d94ccaa$exports($d4af3caa498828ab$var$Uint8ClampedArrayPrototype, $d4af3caa498828ab$var$TypedArrayPrototype);
if ($6fd5c554c2e379fb$exports && !$8c7b2987ef924463$exports($d4af3caa498828ab$var$TypedArrayPrototype, $d4af3caa498828ab$var$TO_STRING_TAG)) {
    $d4af3caa498828ab$var$TYPED_ARRAY_TAG_REQUIRED = true;
    $109566f5adb6d9d6$exports($d4af3caa498828ab$var$TypedArrayPrototype, $d4af3caa498828ab$var$TO_STRING_TAG, {
        configurable: true,
        get: function() {
            return $8c806c3c758c8b3d$exports(this) ? this[$d4af3caa498828ab$var$TYPED_ARRAY_TAG] : undefined;
        }
    });
    for($d4af3caa498828ab$var$NAME in $d4af3caa498828ab$var$TypedArrayConstructorsList)if ($348e6c47a332b0e2$exports[$d4af3caa498828ab$var$NAME]) $eb0a55d196981480$exports($348e6c47a332b0e2$exports[$d4af3caa498828ab$var$NAME], $d4af3caa498828ab$var$TYPED_ARRAY_TAG, $d4af3caa498828ab$var$NAME);
}
$d4af3caa498828ab$exports = {
    NATIVE_ARRAY_BUFFER_VIEWS: $d4af3caa498828ab$var$NATIVE_ARRAY_BUFFER_VIEWS,
    TYPED_ARRAY_TAG: $d4af3caa498828ab$var$TYPED_ARRAY_TAG_REQUIRED && $d4af3caa498828ab$var$TYPED_ARRAY_TAG,
    aTypedArray: $d4af3caa498828ab$var$aTypedArray,
    aTypedArrayConstructor: $d4af3caa498828ab$var$aTypedArrayConstructor,
    exportTypedArrayMethod: $d4af3caa498828ab$var$exportTypedArrayMethod,
    exportTypedArrayStaticMethod: $d4af3caa498828ab$var$exportTypedArrayStaticMethod,
    getTypedArrayConstructor: $d4af3caa498828ab$var$getTypedArrayConstructor,
    isView: $d4af3caa498828ab$var$isView,
    isTypedArray: $d4af3caa498828ab$var$isTypedArray,
    TypedArray: $d4af3caa498828ab$var$TypedArray,
    TypedArrayPrototype: $d4af3caa498828ab$var$TypedArrayPrototype
};


var $8ad785e60d90ed94$exports = {};
'use strict';
var $d62d849626065ae7$exports = {};
'use strict';
var $5b884aab2286183b$exports = {};
'use strict';
var $a84aa20c9a7120f2$exports = {};
'use strict';
var $a84aa20c9a7120f2$var$ceil = Math.ceil;
var $a84aa20c9a7120f2$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
$a84aa20c9a7120f2$exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $a84aa20c9a7120f2$var$floor : $a84aa20c9a7120f2$var$ceil)(n);
};


// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
$5b884aab2286183b$exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $a84aa20c9a7120f2$exports(number);
};


var $d62d849626065ae7$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
$d62d849626065ae7$exports = function(argument) {
    var len = $5b884aab2286183b$exports(argument);
    return len > 0 ? $d62d849626065ae7$var$min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
$8ad785e60d90ed94$exports = function(obj) {
    return $d62d849626065ae7$exports(obj.length);
};


var $9e7751ee79b314e3$exports = {};
'use strict';
var $074fa664e8837a9d$exports = {};
'use strict';

var $074fa664e8837a9d$var$$RangeError = RangeError;
$074fa664e8837a9d$exports = function(it) {
    var result = $5b884aab2286183b$exports(it);
    if (result < 0) throw new $074fa664e8837a9d$var$$RangeError("The argument can't be less than 0");
    return result;
};


var $9e7751ee79b314e3$var$$RangeError = RangeError;
$9e7751ee79b314e3$exports = function(it, BYTES) {
    var offset = $074fa664e8837a9d$exports(it);
    if (offset % BYTES) throw new $9e7751ee79b314e3$var$$RangeError('Wrong offset');
    return offset;
};




var $d71306a9ce6f45cb$var$RangeError = $348e6c47a332b0e2$exports.RangeError;
var $d71306a9ce6f45cb$var$Int8Array = $348e6c47a332b0e2$exports.Int8Array;
var $d71306a9ce6f45cb$var$Int8ArrayPrototype = $d71306a9ce6f45cb$var$Int8Array && $d71306a9ce6f45cb$var$Int8Array.prototype;
var $d71306a9ce6f45cb$var$$set = $d71306a9ce6f45cb$var$Int8ArrayPrototype && $d71306a9ce6f45cb$var$Int8ArrayPrototype.set;
var $d71306a9ce6f45cb$var$aTypedArray = $d4af3caa498828ab$exports.aTypedArray;
var $d71306a9ce6f45cb$var$exportTypedArrayMethod = $d4af3caa498828ab$exports.exportTypedArrayMethod;
var $d71306a9ce6f45cb$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS = !$e5245653e95b5e26$exports(function() {
    // eslint-disable-next-line es/no-typed-arrays -- required for testing
    var array = new Uint8ClampedArray(2);
    $8fe6272fd87552a5$exports($d71306a9ce6f45cb$var$$set, array, {
        length: 1,
        0: 3
    }, 1);
    return array[1] !== 3;
});
// https://bugs.chromium.org/p/v8/issues/detail?id=11294 and other
var $d71306a9ce6f45cb$var$TO_OBJECT_BUG = $d71306a9ce6f45cb$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS && $d4af3caa498828ab$exports.NATIVE_ARRAY_BUFFER_VIEWS && $e5245653e95b5e26$exports(function() {
    var array = new $d71306a9ce6f45cb$var$Int8Array(2);
    array.set(1);
    array.set('2', 1);
    return array[0] !== 0 || array[1] !== 2;
});
// `%TypedArray%.prototype.set` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.set
$d71306a9ce6f45cb$var$exportTypedArrayMethod('set', function set(arrayLike /* , offset */ ) {
    $d71306a9ce6f45cb$var$aTypedArray(this);
    var offset = $9e7751ee79b314e3$exports(arguments.length > 1 ? arguments[1] : undefined, 1);
    var src = $3ebfe248d7ac25da$exports(arrayLike);
    if ($d71306a9ce6f45cb$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS) return $8fe6272fd87552a5$exports($d71306a9ce6f45cb$var$$set, this, src, offset);
    var length = this.length;
    var len = $8ad785e60d90ed94$exports(src);
    var index = 0;
    if (len + offset > length) throw new $d71306a9ce6f45cb$var$RangeError('Wrong length');
    while(index < len)this[offset + index] = src[index++];
}, !$d71306a9ce6f45cb$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS || $d71306a9ce6f45cb$var$TO_OBJECT_BUG);


'use strict';
'use strict';
var $91972c5d4d02eafb$exports = {};
'use strict';

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $d8e12f90fba3a7ec$export$2d1720544b23b823;
'use strict';


// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $7977edb5fe01b7f2$export$2d1720544b23b823;
'use strict';
var $7977edb5fe01b7f2$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $7977edb5fe01b7f2$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $7977edb5fe01b7f2$var$NASHORN_BUG = $7977edb5fe01b7f2$var$getOwnPropertyDescriptor && !$7977edb5fe01b7f2$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$7977edb5fe01b7f2$export$2d1720544b23b823 = $7977edb5fe01b7f2$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $7977edb5fe01b7f2$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $7977edb5fe01b7f2$var$$propertyIsEnumerable;



var $aa926911da5911c9$exports = {};
'use strict';
var $d638f1bd9869775a$exports = {};
'use strict';



var $d638f1bd9869775a$var$$Object = Object;
var $d638f1bd9869775a$var$split = $98d93515e0e907f8$exports(''.split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
$d638f1bd9869775a$exports = $e5245653e95b5e26$exports(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$d638f1bd9869775a$var$$Object('z').propertyIsEnumerable(0);
}) ? function(it) {
    return $182d4f3988cca675$exports(it) === 'String' ? $d638f1bd9869775a$var$split(it, '') : $d638f1bd9869775a$var$$Object(it);
} : $d638f1bd9869775a$var$$Object;



$aa926911da5911c9$exports = function(it) {
    return $d638f1bd9869775a$exports($7f036479c1713728$exports(it));
};





// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $d8e12f90fba3a7ec$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$d8e12f90fba3a7ec$export$2d1720544b23b823 = $6fd5c554c2e379fb$exports ? $d8e12f90fba3a7ec$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $aa926911da5911c9$exports(O);
    P = $fba8d781bbdf6d63$exports(P);
    if ($25d31ffd8582a715$exports) try {
        return $d8e12f90fba3a7ec$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($8c7b2987ef924463$exports(O, P)) return $5bc00574d29a028f$exports(!$8fe6272fd87552a5$exports($7977edb5fe01b7f2$export$2d1720544b23b823, O, P), O[P]);
};


var $91972c5d4d02eafb$require$getOwnPropertyDescriptor = $d8e12f90fba3a7ec$export$2d1720544b23b823;



var $0738aa3164a78aad$exports = {};
'use strict';

var $d144dff5711c38f7$exports = {};
'use strict';


// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $143d825245fa3008$export$2d1720544b23b823;
'use strict';
var $681add6816da5fda$exports = {};
'use strict';



var $dc4c331cb8ef1642$exports = {};
'use strict';

var $c405b28a1a1e7b22$exports = {};
'use strict';

var $c405b28a1a1e7b22$var$max = Math.max;
var $c405b28a1a1e7b22$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
$c405b28a1a1e7b22$exports = function(index, length) {
    var integer = $5b884aab2286183b$exports(index);
    return integer < 0 ? $c405b28a1a1e7b22$var$max(integer + length, 0) : $c405b28a1a1e7b22$var$min(integer, length);
};



// `Array.prototype.{ indexOf, includes }` methods implementation
var $dc4c331cb8ef1642$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $aa926911da5911c9$exports($this);
        var length = $8ad785e60d90ed94$exports(O);
        if (length === 0) return !IS_INCLUDES && -1;
        var index = $c405b28a1a1e7b22$exports(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
$dc4c331cb8ef1642$exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $dc4c331cb8ef1642$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $dc4c331cb8ef1642$var$createMethod(false)
};


var $681add6816da5fda$require$indexOf = $dc4c331cb8ef1642$exports.indexOf;

var $681add6816da5fda$var$push = $98d93515e0e907f8$exports([].push);
$681add6816da5fda$exports = function(object, names) {
    var O = $aa926911da5911c9$exports(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$8c7b2987ef924463$exports($4596fff8ae7ced2f$exports, key) && $8c7b2987ef924463$exports(O, key) && $681add6816da5fda$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($8c7b2987ef924463$exports(O, key = names[i++])) ~$681add6816da5fda$require$indexOf(result, key) || $681add6816da5fda$var$push(result, key);
    return result;
};


var $f89b13ac7820ad38$exports = {};
'use strict';
// IE8- don't enum bug keys
$f89b13ac7820ad38$exports = [
    'constructor',
    'hasOwnProperty',
    'isPrototypeOf',
    'propertyIsEnumerable',
    'toLocaleString',
    'toString',
    'valueOf'
];


var $143d825245fa3008$var$hiddenKeys = $f89b13ac7820ad38$exports.concat('length', 'prototype');
$143d825245fa3008$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $681add6816da5fda$exports(O, $143d825245fa3008$var$hiddenKeys);
};


// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $77987750813dc2a9$export$2d1720544b23b823;
'use strict';
$77987750813dc2a9$export$2d1720544b23b823 = Object.getOwnPropertySymbols;



var $d144dff5711c38f7$var$concat = $98d93515e0e907f8$exports([].concat);
// all object keys, includes non-enumerable and symbols
$d144dff5711c38f7$exports = $7624a7bed62f9402$exports('Reflect', 'ownKeys') || function ownKeys(it) {
    var keys = $143d825245fa3008$export$2d1720544b23b823($1c0d8d4d564036ad$exports(it));
    var getOwnPropertySymbols = $77987750813dc2a9$export$2d1720544b23b823;
    return getOwnPropertySymbols ? $d144dff5711c38f7$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};




$0738aa3164a78aad$exports = function(target, source, exceptions) {
    var keys = $d144dff5711c38f7$exports(source);
    var defineProperty = $8c07b79b91d249fa$export$2d1720544b23b823;
    var getOwnPropertyDescriptor = $d8e12f90fba3a7ec$export$2d1720544b23b823;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$8c7b2987ef924463$exports(target, key) && !(exceptions && $8c7b2987ef924463$exports(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};


var $ea56c6f05b896024$exports = {};
'use strict';


var $ea56c6f05b896024$var$replacement = /#|\.prototype\./;
var $ea56c6f05b896024$var$isForced = function(feature, detection) {
    var value = $ea56c6f05b896024$var$data[$ea56c6f05b896024$var$normalize(feature)];
    return value === $ea56c6f05b896024$var$POLYFILL ? true : value === $ea56c6f05b896024$var$NATIVE ? false : $dbfbedf4ea4a6d09$exports(detection) ? $e5245653e95b5e26$exports(detection) : !!detection;
};
var $ea56c6f05b896024$var$normalize = $ea56c6f05b896024$var$isForced.normalize = function(string) {
    return String(string).replace($ea56c6f05b896024$var$replacement, '.').toLowerCase();
};
var $ea56c6f05b896024$var$data = $ea56c6f05b896024$var$isForced.data = {};
var $ea56c6f05b896024$var$NATIVE = $ea56c6f05b896024$var$isForced.NATIVE = 'N';
var $ea56c6f05b896024$var$POLYFILL = $ea56c6f05b896024$var$isForced.POLYFILL = 'P';
$ea56c6f05b896024$exports = $ea56c6f05b896024$var$isForced;


/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ $91972c5d4d02eafb$exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $348e6c47a332b0e2$exports;
    else if (STATIC) target = $348e6c47a332b0e2$exports[TARGET] || $89acf2497e4c2cee$exports(TARGET, {});
    else target = $348e6c47a332b0e2$exports[TARGET] && $348e6c47a332b0e2$exports[TARGET].prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $91972c5d4d02eafb$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $ea56c6f05b896024$exports(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $0738aa3164a78aad$exports(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $eb0a55d196981480$exports(sourceProperty, 'sham', true);
        $3fdb65a5c6da057e$exports(target, key, sourceProperty, options);
    }
};



var $ca97d3bc535c87ac$exports = {};
'use strict';

var $829997cad946046a$exports = {};
'use strict';

var $829997cad946046a$var$FunctionPrototype = Function.prototype;
var $829997cad946046a$var$apply = $829997cad946046a$var$FunctionPrototype.apply;
var $829997cad946046a$var$call = $829997cad946046a$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-function-prototype-bind, es/no-reflect -- safe
$829997cad946046a$exports = typeof Reflect == 'object' && Reflect.apply || ($2cc708c704b2ff0e$exports ? $829997cad946046a$var$call.bind($829997cad946046a$var$apply) : function() {
    return $829997cad946046a$var$call.apply($829997cad946046a$var$apply, arguments);
});


var $4360505418c0503b$exports = {};
'use strict';
var $05676fe919bd7d5f$exports = {};
'use strict';


$05676fe919bd7d5f$exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($182d4f3988cca675$exports(fn) === 'Function') return $98d93515e0e907f8$exports(fn);
};




var $4360505418c0503b$var$bind = $05676fe919bd7d5f$exports($05676fe919bd7d5f$exports.bind);
// optional / simple context binding
$4360505418c0503b$exports = function(fn, that) {
    $4b16eff6617840b7$exports(fn);
    return that === undefined ? fn : $2cc708c704b2ff0e$exports ? $4360505418c0503b$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};





var $d494e701c25e56c0$exports = {};
'use strict';

$d494e701c25e56c0$exports = $7624a7bed62f9402$exports('document', 'documentElement');


var $0fc44c6dbb504c8d$exports = {};
'use strict';

$0fc44c6dbb504c8d$exports = $98d93515e0e907f8$exports([].slice);



var $8ddcbec693028d43$exports = {};
'use strict';
var $8ddcbec693028d43$var$$TypeError = TypeError;
$8ddcbec693028d43$exports = function(passed, required) {
    if (passed < required) throw new $8ddcbec693028d43$var$$TypeError('Not enough arguments');
    return passed;
};


var $ad5381cf5752e81c$exports = {};
'use strict';

// eslint-disable-next-line redos/no-vulnerable -- safe
$ad5381cf5752e81c$exports = /(?:ipad|iphone|ipod).*applewebkit/i.test($60cc6c89a84ad112$exports);


var $f7cbc5960bc69115$exports = {};
'use strict';
var $1b1e60febeb5b92a$exports = {};
'use strict';



var $1b1e60febeb5b92a$var$userAgentStartsWith = function(string) {
    return $60cc6c89a84ad112$exports.slice(0, string.length) === string;
};
$1b1e60febeb5b92a$exports = function() {
    if ($1b1e60febeb5b92a$var$userAgentStartsWith('Bun/')) return 'BUN';
    if ($1b1e60febeb5b92a$var$userAgentStartsWith('Cloudflare-Workers')) return 'CLOUDFLARE';
    if ($1b1e60febeb5b92a$var$userAgentStartsWith('Deno/')) return 'DENO';
    if ($1b1e60febeb5b92a$var$userAgentStartsWith('Node.js/')) return 'NODE';
    if ($348e6c47a332b0e2$exports.Bun && typeof Bun.version == 'string') return 'BUN';
    if ($348e6c47a332b0e2$exports.Deno && typeof Deno.version == 'object') return 'DENO';
    if ($182d4f3988cca675$exports($348e6c47a332b0e2$exports.process) === 'process') return 'NODE';
    if ($348e6c47a332b0e2$exports.window && $348e6c47a332b0e2$exports.document) return 'BROWSER';
    return 'REST';
}();


$f7cbc5960bc69115$exports = $1b1e60febeb5b92a$exports === 'NODE';


var $ca97d3bc535c87ac$var$set = $348e6c47a332b0e2$exports.setImmediate;
var $ca97d3bc535c87ac$var$clear = $348e6c47a332b0e2$exports.clearImmediate;
var $ca97d3bc535c87ac$var$process = $348e6c47a332b0e2$exports.process;
var $ca97d3bc535c87ac$var$Dispatch = $348e6c47a332b0e2$exports.Dispatch;
var $ca97d3bc535c87ac$var$Function = $348e6c47a332b0e2$exports.Function;
var $ca97d3bc535c87ac$var$MessageChannel = $348e6c47a332b0e2$exports.MessageChannel;
var $ca97d3bc535c87ac$var$String = $348e6c47a332b0e2$exports.String;
var $ca97d3bc535c87ac$var$counter = 0;
var $ca97d3bc535c87ac$var$queue = {};
var $ca97d3bc535c87ac$var$ONREADYSTATECHANGE = 'onreadystatechange';
var $ca97d3bc535c87ac$var$$location, $ca97d3bc535c87ac$var$defer, $ca97d3bc535c87ac$var$channel, $ca97d3bc535c87ac$var$port;
$e5245653e95b5e26$exports(function() {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $ca97d3bc535c87ac$var$$location = $348e6c47a332b0e2$exports.location;
});
var $ca97d3bc535c87ac$var$run = function(id) {
    if ($8c7b2987ef924463$exports($ca97d3bc535c87ac$var$queue, id)) {
        var fn = $ca97d3bc535c87ac$var$queue[id];
        delete $ca97d3bc535c87ac$var$queue[id];
        fn();
    }
};
var $ca97d3bc535c87ac$var$runner = function(id) {
    return function() {
        $ca97d3bc535c87ac$var$run(id);
    };
};
var $ca97d3bc535c87ac$var$eventListener = function(event) {
    $ca97d3bc535c87ac$var$run(event.data);
};
var $ca97d3bc535c87ac$var$globalPostMessageDefer = function(id) {
    // old engines have not location.origin
    $348e6c47a332b0e2$exports.postMessage($ca97d3bc535c87ac$var$String(id), $ca97d3bc535c87ac$var$$location.protocol + '//' + $ca97d3bc535c87ac$var$$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$ca97d3bc535c87ac$var$set || !$ca97d3bc535c87ac$var$clear) {
    $ca97d3bc535c87ac$var$set = function setImmediate(handler) {
        $8ddcbec693028d43$exports(arguments.length, 1);
        var fn = $dbfbedf4ea4a6d09$exports(handler) ? handler : $ca97d3bc535c87ac$var$Function(handler);
        var args = $0fc44c6dbb504c8d$exports(arguments, 1);
        $ca97d3bc535c87ac$var$queue[++$ca97d3bc535c87ac$var$counter] = function() {
            $829997cad946046a$exports(fn, undefined, args);
        };
        $ca97d3bc535c87ac$var$defer($ca97d3bc535c87ac$var$counter);
        return $ca97d3bc535c87ac$var$counter;
    };
    $ca97d3bc535c87ac$var$clear = function clearImmediate(id) {
        delete $ca97d3bc535c87ac$var$queue[id];
    };
    // Node.js 0.8-
    if ($f7cbc5960bc69115$exports) $ca97d3bc535c87ac$var$defer = function(id) {
        $ca97d3bc535c87ac$var$process.nextTick($ca97d3bc535c87ac$var$runner(id));
    };
    else if ($ca97d3bc535c87ac$var$Dispatch && $ca97d3bc535c87ac$var$Dispatch.now) $ca97d3bc535c87ac$var$defer = function(id) {
        $ca97d3bc535c87ac$var$Dispatch.now($ca97d3bc535c87ac$var$runner(id));
    };
    else if ($ca97d3bc535c87ac$var$MessageChannel && !$ad5381cf5752e81c$exports) {
        $ca97d3bc535c87ac$var$channel = new $ca97d3bc535c87ac$var$MessageChannel();
        $ca97d3bc535c87ac$var$port = $ca97d3bc535c87ac$var$channel.port2;
        $ca97d3bc535c87ac$var$channel.port1.onmessage = $ca97d3bc535c87ac$var$eventListener;
        $ca97d3bc535c87ac$var$defer = $4360505418c0503b$exports($ca97d3bc535c87ac$var$port.postMessage, $ca97d3bc535c87ac$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($348e6c47a332b0e2$exports.addEventListener && $dbfbedf4ea4a6d09$exports($348e6c47a332b0e2$exports.postMessage) && !$348e6c47a332b0e2$exports.importScripts && $ca97d3bc535c87ac$var$$location && $ca97d3bc535c87ac$var$$location.protocol !== 'file:' && !$e5245653e95b5e26$exports($ca97d3bc535c87ac$var$globalPostMessageDefer)) {
        $ca97d3bc535c87ac$var$defer = $ca97d3bc535c87ac$var$globalPostMessageDefer;
        $348e6c47a332b0e2$exports.addEventListener('message', $ca97d3bc535c87ac$var$eventListener, false);
    // IE8-
    } else if ($ca97d3bc535c87ac$var$ONREADYSTATECHANGE in $8f4cb3cc8c4f2470$exports('script')) $ca97d3bc535c87ac$var$defer = function(id) {
        $d494e701c25e56c0$exports.appendChild($8f4cb3cc8c4f2470$exports('script'))[$ca97d3bc535c87ac$var$ONREADYSTATECHANGE] = function() {
            $d494e701c25e56c0$exports.removeChild(this);
            $ca97d3bc535c87ac$var$run(id);
        };
    };
    else $ca97d3bc535c87ac$var$defer = function(id) {
        setTimeout($ca97d3bc535c87ac$var$runner(id), 0);
    };
}
$ca97d3bc535c87ac$exports = {
    set: $ca97d3bc535c87ac$var$set,
    clear: $ca97d3bc535c87ac$var$clear
};


var $5113e14d2682197d$require$clearImmediate = $ca97d3bc535c87ac$exports.clear;
// `clearImmediate` method
// http://w3c.github.io/setImmediate/#si-clearImmediate
$91972c5d4d02eafb$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $348e6c47a332b0e2$exports.clearImmediate !== $5113e14d2682197d$require$clearImmediate
}, {
    clearImmediate: $5113e14d2682197d$require$clearImmediate
});


'use strict';



var $8fd87bed3014f95a$require$setTask = $ca97d3bc535c87ac$exports.set;
var $336edcf3268f7b73$exports = {};
'use strict';







var $336edcf3268f7b73$var$Function = $348e6c47a332b0e2$exports.Function;
// dirty IE9- and Bun 0.3.0- checks
var $336edcf3268f7b73$var$WRAP = /MSIE .\./.test($60cc6c89a84ad112$exports) || $1b1e60febeb5b92a$exports === 'BUN' && function() {
    var version = $348e6c47a332b0e2$exports.Bun.version.split('.');
    return version.length < 3 || version[0] === '0' && (version[1] < 3 || version[1] === '3' && version[2] === '0');
}();
// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
// https://github.com/oven-sh/bun/issues/1633
$336edcf3268f7b73$exports = function(scheduler, hasTimeArg) {
    var firstParamIndex = hasTimeArg ? 2 : 1;
    return $336edcf3268f7b73$var$WRAP ? function(handler, timeout /* , ...arguments */ ) {
        var boundArgs = $8ddcbec693028d43$exports(arguments.length, 1) > firstParamIndex;
        var fn = $dbfbedf4ea4a6d09$exports(handler) ? handler : $336edcf3268f7b73$var$Function(handler);
        var params = boundArgs ? $0fc44c6dbb504c8d$exports(arguments, firstParamIndex) : [];
        var callback = boundArgs ? function() {
            $829997cad946046a$exports(fn, this, params);
        } : fn;
        return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
    } : scheduler;
};


// https://github.com/oven-sh/bun/issues/1633
var $8fd87bed3014f95a$var$setImmediate = $348e6c47a332b0e2$exports.setImmediate ? $336edcf3268f7b73$exports($8fd87bed3014f95a$require$setTask, false) : $8fd87bed3014f95a$require$setTask;
// `setImmediate` method
// http://w3c.github.io/setImmediate/#si-setImmediate
$91972c5d4d02eafb$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $348e6c47a332b0e2$exports.setImmediate !== $8fd87bed3014f95a$var$setImmediate
}, {
    setImmediate: $8fd87bed3014f95a$var$setImmediate
});




var $d82bb7e981e809fe$export$402e76927ebf6a24 = [];


var $a5556e619162cf22$export$63c81bd924f89474 = function() {
    return (0, $d82bb7e981e809fe$export$402e76927ebf6a24).some(function(ro) {
        return ro.activeTargets.length > 0;
    });
};



var $32a2484a76c4e86f$export$8ca35300535e324d = function() {
    return (0, $d82bb7e981e809fe$export$402e76927ebf6a24).some(function(ro) {
        return ro.skippedTargets.length > 0;
    });
};


var $4aeca2c0ab2bd112$var$msg = 'ResizeObserver loop completed with undelivered notifications.';
var $4aeca2c0ab2bd112$export$888cb69481582149 = function() {
    var event;
    if (typeof ErrorEvent === 'function') event = new ErrorEvent('error', {
        message: $4aeca2c0ab2bd112$var$msg
    });
    else {
        event = document.createEvent('Event');
        event.initEvent('error', false, false);
        event.message = $4aeca2c0ab2bd112$var$msg;
    }
    window.dispatchEvent(event);
};



var $25313f81f9a8f797$export$416d111b83cd1483;
(function(ResizeObserverBoxOptions) {
    ResizeObserverBoxOptions["BORDER_BOX"] = "border-box";
    ResizeObserverBoxOptions["CONTENT_BOX"] = "content-box";
    ResizeObserverBoxOptions["DEVICE_PIXEL_CONTENT_BOX"] = "device-pixel-content-box";
})($25313f81f9a8f797$export$416d111b83cd1483 || ($25313f81f9a8f797$export$416d111b83cd1483 = {}));


var $f1b7af0d87abad31$export$792f3d81ea979f55 = function(obj) {
    return Object.freeze(obj);
};


var $a9fef4df7451bd76$export$c9ad8cdf6bbd331c = function() {
    function ResizeObserverSize(inlineSize, blockSize) {
        this.inlineSize = inlineSize;
        this.blockSize = blockSize;
        (0, $f1b7af0d87abad31$export$792f3d81ea979f55)(this);
    }
    return ResizeObserverSize;
}();



var $60abdc953c5026b2$export$51d7a67026f4e0b7 = function() {
    function DOMRectReadOnly(x, y, width, height) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.top = this.y;
        this.left = this.x;
        this.bottom = this.top + this.height;
        this.right = this.left + this.width;
        return (0, $f1b7af0d87abad31$export$792f3d81ea979f55)(this);
    }
    DOMRectReadOnly.prototype.toJSON = function() {
        var _a = this, x = _a.x, y = _a.y, top = _a.top, right = _a.right, bottom = _a.bottom, left = _a.left, width = _a.width, height = _a.height;
        return {
            x: x,
            y: y,
            top: top,
            right: right,
            bottom: bottom,
            left: left,
            width: width,
            height: height
        };
    };
    DOMRectReadOnly.fromRect = function(rectangle) {
        return new DOMRectReadOnly(rectangle.x, rectangle.y, rectangle.width, rectangle.height);
    };
    return DOMRectReadOnly;
}();


var $c4eb89e3f4e99df0$export$165b39ed277223c2 = function(target) {
    return target instanceof SVGElement && 'getBBox' in target;
};
var $c4eb89e3f4e99df0$export$ee695c13482bb5dd = function(target) {
    if ($c4eb89e3f4e99df0$export$165b39ed277223c2(target)) {
        var _a = target.getBBox(), width = _a.width, height = _a.height;
        return !width && !height;
    }
    var _b = target, offsetWidth = _b.offsetWidth, offsetHeight = _b.offsetHeight;
    return !(offsetWidth || offsetHeight || target.getClientRects().length);
};
var $c4eb89e3f4e99df0$export$45a5e7f76e0caa8d = function(obj) {
    var _a;
    if (obj instanceof Element) return true;
    var scope = (_a = obj === null || obj === void 0 ? void 0 : obj.ownerDocument) === null || _a === void 0 ? void 0 : _a.defaultView;
    return !!(scope && obj instanceof scope.Element);
};
var $c4eb89e3f4e99df0$export$a6eb60f7e7c182ba = function(target) {
    switch(target.tagName){
        case 'INPUT':
            if (target.type !== 'image') break;
        case 'VIDEO':
        case 'AUDIO':
        case 'EMBED':
        case 'OBJECT':
        case 'CANVAS':
        case 'IFRAME':
        case 'IMG':
            return true;
    }
    return false;
};



var $d70c655161bff124$export$90b4d2ff6acb88af = typeof window !== 'undefined' ? window : {};


var $771bfb0ecf2eadca$var$cache = new WeakMap();
var $771bfb0ecf2eadca$var$scrollRegexp = /auto|scroll/;
var $771bfb0ecf2eadca$var$verticalRegexp = /^tb|vertical/;
var $771bfb0ecf2eadca$var$IE = /msie|trident/i.test((0, $d70c655161bff124$export$90b4d2ff6acb88af).navigator && (0, $d70c655161bff124$export$90b4d2ff6acb88af).navigator.userAgent);
var $771bfb0ecf2eadca$var$parseDimension = function(pixel) {
    return parseFloat(pixel || '0');
};
var $771bfb0ecf2eadca$var$size = function(inlineSize, blockSize, switchSizes) {
    if (inlineSize === void 0) inlineSize = 0;
    if (blockSize === void 0) blockSize = 0;
    if (switchSizes === void 0) switchSizes = false;
    return new (0, $a9fef4df7451bd76$export$c9ad8cdf6bbd331c)((switchSizes ? blockSize : inlineSize) || 0, (switchSizes ? inlineSize : blockSize) || 0);
};
var $771bfb0ecf2eadca$var$zeroBoxes = (0, $f1b7af0d87abad31$export$792f3d81ea979f55)({
    devicePixelContentBoxSize: $771bfb0ecf2eadca$var$size(),
    borderBoxSize: $771bfb0ecf2eadca$var$size(),
    contentBoxSize: $771bfb0ecf2eadca$var$size(),
    contentRect: new (0, $60abdc953c5026b2$export$51d7a67026f4e0b7)(0, 0, 0, 0)
});
var $771bfb0ecf2eadca$export$504d039a9c501c94 = function(target, forceRecalculation) {
    if (forceRecalculation === void 0) forceRecalculation = false;
    if ($771bfb0ecf2eadca$var$cache.has(target) && !forceRecalculation) return $771bfb0ecf2eadca$var$cache.get(target);
    if ((0, $c4eb89e3f4e99df0$export$ee695c13482bb5dd)(target)) {
        $771bfb0ecf2eadca$var$cache.set(target, $771bfb0ecf2eadca$var$zeroBoxes);
        return $771bfb0ecf2eadca$var$zeroBoxes;
    }
    var cs = getComputedStyle(target);
    var svg = (0, $c4eb89e3f4e99df0$export$165b39ed277223c2)(target) && target.ownerSVGElement && target.getBBox();
    var removePadding = !$771bfb0ecf2eadca$var$IE && cs.boxSizing === 'border-box';
    var switchSizes = $771bfb0ecf2eadca$var$verticalRegexp.test(cs.writingMode || '');
    var canScrollVertically = !svg && $771bfb0ecf2eadca$var$scrollRegexp.test(cs.overflowY || '');
    var canScrollHorizontally = !svg && $771bfb0ecf2eadca$var$scrollRegexp.test(cs.overflowX || '');
    var paddingTop = svg ? 0 : $771bfb0ecf2eadca$var$parseDimension(cs.paddingTop);
    var paddingRight = svg ? 0 : $771bfb0ecf2eadca$var$parseDimension(cs.paddingRight);
    var paddingBottom = svg ? 0 : $771bfb0ecf2eadca$var$parseDimension(cs.paddingBottom);
    var paddingLeft = svg ? 0 : $771bfb0ecf2eadca$var$parseDimension(cs.paddingLeft);
    var borderTop = svg ? 0 : $771bfb0ecf2eadca$var$parseDimension(cs.borderTopWidth);
    var borderRight = svg ? 0 : $771bfb0ecf2eadca$var$parseDimension(cs.borderRightWidth);
    var borderBottom = svg ? 0 : $771bfb0ecf2eadca$var$parseDimension(cs.borderBottomWidth);
    var borderLeft = svg ? 0 : $771bfb0ecf2eadca$var$parseDimension(cs.borderLeftWidth);
    var horizontalPadding = paddingLeft + paddingRight;
    var verticalPadding = paddingTop + paddingBottom;
    var horizontalBorderArea = borderLeft + borderRight;
    var verticalBorderArea = borderTop + borderBottom;
    var horizontalScrollbarThickness = !canScrollHorizontally ? 0 : target.offsetHeight - verticalBorderArea - target.clientHeight;
    var verticalScrollbarThickness = !canScrollVertically ? 0 : target.offsetWidth - horizontalBorderArea - target.clientWidth;
    var widthReduction = removePadding ? horizontalPadding + horizontalBorderArea : 0;
    var heightReduction = removePadding ? verticalPadding + verticalBorderArea : 0;
    var contentWidth = svg ? svg.width : $771bfb0ecf2eadca$var$parseDimension(cs.width) - widthReduction - verticalScrollbarThickness;
    var contentHeight = svg ? svg.height : $771bfb0ecf2eadca$var$parseDimension(cs.height) - heightReduction - horizontalScrollbarThickness;
    var borderBoxWidth = contentWidth + horizontalPadding + verticalScrollbarThickness + horizontalBorderArea;
    var borderBoxHeight = contentHeight + verticalPadding + horizontalScrollbarThickness + verticalBorderArea;
    var boxes = (0, $f1b7af0d87abad31$export$792f3d81ea979f55)({
        devicePixelContentBoxSize: $771bfb0ecf2eadca$var$size(Math.round(contentWidth * devicePixelRatio), Math.round(contentHeight * devicePixelRatio), switchSizes),
        borderBoxSize: $771bfb0ecf2eadca$var$size(borderBoxWidth, borderBoxHeight, switchSizes),
        contentBoxSize: $771bfb0ecf2eadca$var$size(contentWidth, contentHeight, switchSizes),
        contentRect: new (0, $60abdc953c5026b2$export$51d7a67026f4e0b7)(paddingLeft, paddingTop, contentWidth, contentHeight)
    });
    $771bfb0ecf2eadca$var$cache.set(target, boxes);
    return boxes;
};
var $771bfb0ecf2eadca$export$1a78030b04106bdb = function(target, observedBox, forceRecalculation) {
    var _a = $771bfb0ecf2eadca$export$504d039a9c501c94(target, forceRecalculation), borderBoxSize = _a.borderBoxSize, contentBoxSize = _a.contentBoxSize, devicePixelContentBoxSize = _a.devicePixelContentBoxSize;
    switch(observedBox){
        case (0, $25313f81f9a8f797$export$416d111b83cd1483).DEVICE_PIXEL_CONTENT_BOX:
            return devicePixelContentBoxSize;
        case (0, $25313f81f9a8f797$export$416d111b83cd1483).BORDER_BOX:
            return borderBoxSize;
        default:
            return contentBoxSize;
    }
};



var $db51179e63ad4f3c$export$226159b441fc89f8 = function() {
    function ResizeObserverEntry(target) {
        var boxes = (0, $771bfb0ecf2eadca$export$504d039a9c501c94)(target);
        this.target = target;
        this.contentRect = boxes.contentRect;
        this.borderBoxSize = (0, $f1b7af0d87abad31$export$792f3d81ea979f55)([
            boxes.borderBoxSize
        ]);
        this.contentBoxSize = (0, $f1b7af0d87abad31$export$792f3d81ea979f55)([
            boxes.contentBoxSize
        ]);
        this.devicePixelContentBoxSize = (0, $f1b7af0d87abad31$export$792f3d81ea979f55)([
            boxes.devicePixelContentBoxSize
        ]);
    }
    return ResizeObserverEntry;
}();



var $bc8ea2497ef542e1$export$f8c8e3b5da1f41d2 = function(node) {
    if ((0, $c4eb89e3f4e99df0$export$ee695c13482bb5dd)(node)) return Infinity;
    var depth = 0;
    var parent = node.parentNode;
    while(parent){
        depth += 1;
        parent = parent.parentNode;
    }
    return depth;
};



var $4bce20cc2076d2f5$export$9cac928141e5443b = function() {
    var shallowestDepth = Infinity;
    var callbacks = [];
    (0, $d82bb7e981e809fe$export$402e76927ebf6a24).forEach(function processObserver(ro) {
        if (ro.activeTargets.length === 0) return;
        var entries = [];
        ro.activeTargets.forEach(function processTarget(ot) {
            var entry = new (0, $db51179e63ad4f3c$export$226159b441fc89f8)(ot.target);
            var targetDepth = (0, $bc8ea2497ef542e1$export$f8c8e3b5da1f41d2)(ot.target);
            entries.push(entry);
            ot.lastReportedSize = (0, $771bfb0ecf2eadca$export$1a78030b04106bdb)(ot.target, ot.observedBox);
            if (targetDepth < shallowestDepth) shallowestDepth = targetDepth;
        });
        callbacks.push(function resizeObserverCallback() {
            ro.callback.call(ro.observer, entries, ro.observer);
        });
        ro.activeTargets.splice(0, ro.activeTargets.length);
    });
    for(var _i = 0, callbacks_1 = callbacks; _i < callbacks_1.length; _i++){
        var callback = callbacks_1[_i];
        callback();
    }
    return shallowestDepth;
};




var $e4a026ea5ffadd7f$export$9c17b8913a2a3572 = function(depth) {
    (0, $d82bb7e981e809fe$export$402e76927ebf6a24).forEach(function processObserver(ro) {
        ro.activeTargets.splice(0, ro.activeTargets.length);
        ro.skippedTargets.splice(0, ro.skippedTargets.length);
        ro.observationTargets.forEach(function processTarget(ot) {
            if (ot.isActive()) {
                if ((0, $bc8ea2497ef542e1$export$f8c8e3b5da1f41d2)(ot.target) > depth) ro.activeTargets.push(ot);
                else ro.skippedTargets.push(ot);
            }
        });
    });
};


var $66cfb907e2f3e155$export$e54fe5b0f43758f7 = function() {
    var depth = 0;
    (0, $e4a026ea5ffadd7f$export$9c17b8913a2a3572)(depth);
    while((0, $a5556e619162cf22$export$63c81bd924f89474)()){
        depth = (0, $4bce20cc2076d2f5$export$9cac928141e5443b)();
        (0, $e4a026ea5ffadd7f$export$9c17b8913a2a3572)(depth);
    }
    if ((0, $32a2484a76c4e86f$export$8ca35300535e324d)()) (0, $4aeca2c0ab2bd112$export$888cb69481582149)();
    return depth > 0;
};



var $26a557b6fb23af97$var$trigger;
var $26a557b6fb23af97$var$callbacks = [];
var $26a557b6fb23af97$var$notify = function() {
    return $26a557b6fb23af97$var$callbacks.splice(0).forEach(function(cb) {
        return cb();
    });
};
var $26a557b6fb23af97$export$4c995d4933c4abb = function(callback) {
    if (!$26a557b6fb23af97$var$trigger) {
        var toggle_1 = 0;
        var el_1 = document.createTextNode('');
        var config = {
            characterData: true
        };
        new MutationObserver(function() {
            return $26a557b6fb23af97$var$notify();
        }).observe(el_1, config);
        $26a557b6fb23af97$var$trigger = function() {
            el_1.textContent = "".concat(toggle_1 ? toggle_1-- : toggle_1++);
        };
    }
    $26a557b6fb23af97$var$callbacks.push(callback);
    $26a557b6fb23af97$var$trigger();
};


var $a4976c44003c20fe$export$5755c7b572e34c6 = function(cb) {
    (0, $26a557b6fb23af97$export$4c995d4933c4abb)(function ResizeObserver() {
        requestAnimationFrame(cb);
    });
};


var $3a990de85cb027bf$var$watching = 0;
var $3a990de85cb027bf$var$isWatching = function() {
    return !!$3a990de85cb027bf$var$watching;
};
var $3a990de85cb027bf$var$CATCH_PERIOD = 250;
var $3a990de85cb027bf$var$observerConfig = {
    attributes: true,
    characterData: true,
    childList: true,
    subtree: true
};
var $3a990de85cb027bf$var$events = [
    'resize',
    'load',
    'transitionend',
    'animationend',
    'animationstart',
    'animationiteration',
    'keyup',
    'keydown',
    'mouseup',
    'mousedown',
    'mouseover',
    'mouseout',
    'blur',
    'focus'
];
var $3a990de85cb027bf$var$time = function(timeout) {
    if (timeout === void 0) timeout = 0;
    return Date.now() + timeout;
};
var $3a990de85cb027bf$var$scheduled = false;
var $3a990de85cb027bf$var$Scheduler = function() {
    function Scheduler() {
        var _this = this;
        this.stopped = true;
        this.listener = function() {
            return _this.schedule();
        };
    }
    Scheduler.prototype.run = function(timeout) {
        var _this = this;
        if (timeout === void 0) timeout = $3a990de85cb027bf$var$CATCH_PERIOD;
        if ($3a990de85cb027bf$var$scheduled) return;
        $3a990de85cb027bf$var$scheduled = true;
        var until = $3a990de85cb027bf$var$time(timeout);
        (0, $a4976c44003c20fe$export$5755c7b572e34c6)(function() {
            var elementsHaveResized = false;
            try {
                elementsHaveResized = (0, $66cfb907e2f3e155$export$e54fe5b0f43758f7)();
            } finally{
                $3a990de85cb027bf$var$scheduled = false;
                timeout = until - $3a990de85cb027bf$var$time();
                if (!$3a990de85cb027bf$var$isWatching()) return;
                if (elementsHaveResized) _this.run(1000);
                else if (timeout > 0) _this.run(timeout);
                else _this.start();
            }
        });
    };
    Scheduler.prototype.schedule = function() {
        this.stop();
        this.run();
    };
    Scheduler.prototype.observe = function() {
        var _this = this;
        var cb = function() {
            return _this.observer && _this.observer.observe(document.body, $3a990de85cb027bf$var$observerConfig);
        };
        document.body ? cb() : (0, $d70c655161bff124$export$90b4d2ff6acb88af).addEventListener('DOMContentLoaded', cb);
    };
    Scheduler.prototype.start = function() {
        var _this = this;
        if (this.stopped) {
            this.stopped = false;
            this.observer = new MutationObserver(this.listener);
            this.observe();
            $3a990de85cb027bf$var$events.forEach(function(name) {
                return (0, $d70c655161bff124$export$90b4d2ff6acb88af).addEventListener(name, _this.listener, true);
            });
        }
    };
    Scheduler.prototype.stop = function() {
        var _this = this;
        if (!this.stopped) {
            this.observer && this.observer.disconnect();
            $3a990de85cb027bf$var$events.forEach(function(name) {
                return (0, $d70c655161bff124$export$90b4d2ff6acb88af).removeEventListener(name, _this.listener, true);
            });
            this.stopped = true;
        }
    };
    return Scheduler;
}();
var $3a990de85cb027bf$export$d30788f2c20241cd = new $3a990de85cb027bf$var$Scheduler();
var $3a990de85cb027bf$export$1f18a74d42722835 = function(n) {
    !$3a990de85cb027bf$var$watching && n > 0 && $3a990de85cb027bf$export$d30788f2c20241cd.start();
    $3a990de85cb027bf$var$watching += n;
    !$3a990de85cb027bf$var$watching && $3a990de85cb027bf$export$d30788f2c20241cd.stop();
};





var $5f7a606a67402962$var$skipNotifyOnElement = function(target) {
    return !(0, $c4eb89e3f4e99df0$export$165b39ed277223c2)(target) && !(0, $c4eb89e3f4e99df0$export$a6eb60f7e7c182ba)(target) && getComputedStyle(target).display === 'inline';
};
var $5f7a606a67402962$export$fea412043713122 = function() {
    function ResizeObservation(target, observedBox) {
        this.target = target;
        this.observedBox = observedBox || (0, $25313f81f9a8f797$export$416d111b83cd1483).CONTENT_BOX;
        this.lastReportedSize = {
            inlineSize: 0,
            blockSize: 0
        };
    }
    ResizeObservation.prototype.isActive = function() {
        var size = (0, $771bfb0ecf2eadca$export$1a78030b04106bdb)(this.target, this.observedBox, true);
        if ($5f7a606a67402962$var$skipNotifyOnElement(this.target)) this.lastReportedSize = size;
        if (this.lastReportedSize.inlineSize !== size.inlineSize || this.lastReportedSize.blockSize !== size.blockSize) return true;
        return false;
    };
    return ResizeObservation;
}();


var $521853965c06da57$export$d86966e6e4bc97e1 = function() {
    function ResizeObserverDetail(resizeObserver, callback) {
        this.activeTargets = [];
        this.skippedTargets = [];
        this.observationTargets = [];
        this.observer = resizeObserver;
        this.callback = callback;
    }
    return ResizeObserverDetail;
}();



var $921da1210d0da43c$var$observerMap = new WeakMap();
var $921da1210d0da43c$var$getObservationIndex = function(observationTargets, target) {
    for(var i = 0; i < observationTargets.length; i += 1){
        if (observationTargets[i].target === target) return i;
    }
    return -1;
};
var $921da1210d0da43c$export$ed99c5bafbaf8300 = function() {
    function ResizeObserverController() {}
    ResizeObserverController.connect = function(resizeObserver, callback) {
        var detail = new (0, $521853965c06da57$export$d86966e6e4bc97e1)(resizeObserver, callback);
        $921da1210d0da43c$var$observerMap.set(resizeObserver, detail);
    };
    ResizeObserverController.observe = function(resizeObserver, target, options) {
        var detail = $921da1210d0da43c$var$observerMap.get(resizeObserver);
        var firstObservation = detail.observationTargets.length === 0;
        if ($921da1210d0da43c$var$getObservationIndex(detail.observationTargets, target) < 0) {
            firstObservation && (0, $d82bb7e981e809fe$export$402e76927ebf6a24).push(detail);
            detail.observationTargets.push(new (0, $5f7a606a67402962$export$fea412043713122)(target, options && options.box));
            (0, $3a990de85cb027bf$export$1f18a74d42722835)(1);
            (0, $3a990de85cb027bf$export$d30788f2c20241cd).schedule();
        }
    };
    ResizeObserverController.unobserve = function(resizeObserver, target) {
        var detail = $921da1210d0da43c$var$observerMap.get(resizeObserver);
        var index = $921da1210d0da43c$var$getObservationIndex(detail.observationTargets, target);
        var lastObservation = detail.observationTargets.length === 1;
        if (index >= 0) {
            lastObservation && (0, $d82bb7e981e809fe$export$402e76927ebf6a24).splice((0, $d82bb7e981e809fe$export$402e76927ebf6a24).indexOf(detail), 1);
            detail.observationTargets.splice(index, 1);
            (0, $3a990de85cb027bf$export$1f18a74d42722835)(-1);
        }
    };
    ResizeObserverController.disconnect = function(resizeObserver) {
        var _this = this;
        var detail = $921da1210d0da43c$var$observerMap.get(resizeObserver);
        detail.observationTargets.slice().forEach(function(ot) {
            return _this.unobserve(resizeObserver, ot.target);
        });
        detail.activeTargets.splice(0, detail.activeTargets.length);
    };
    return ResizeObserverController;
}();



var $860d6ac538e2d2af$export$9caf76241ca21a11 = function() {
    function ResizeObserver(callback) {
        if (arguments.length === 0) throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
        if (typeof callback !== 'function') throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
        (0, $921da1210d0da43c$export$ed99c5bafbaf8300).connect(this, callback);
    }
    ResizeObserver.prototype.observe = function(target, options) {
        if (arguments.length === 0) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
        if (!(0, $c4eb89e3f4e99df0$export$45a5e7f76e0caa8d)(target)) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
        (0, $921da1210d0da43c$export$ed99c5bafbaf8300).observe(this, target, options);
    };
    ResizeObserver.prototype.unobserve = function(target) {
        if (arguments.length === 0) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
        if (!(0, $c4eb89e3f4e99df0$export$45a5e7f76e0caa8d)(target)) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
        (0, $921da1210d0da43c$export$ed99c5bafbaf8300).unobserve(this, target);
    };
    ResizeObserver.prototype.disconnect = function() {
        (0, $921da1210d0da43c$export$ed99c5bafbaf8300).disconnect(this);
    };
    ResizeObserver.toString = function() {
        return 'function ResizeObserver () { [polyfill code] }';
    };
    return ResizeObserver;
}();






var $b48770f827831fc3$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b48770f827831fc3$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per GeneratorResume behavior specified since ES2015:
                // ES2015 spec, step 3: https://262.ecma-international.org/6.0/#sec-generatorresume
                // Latest spec, step 2: https://tc39.es/ecma262/#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next method, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable != null) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        throw new TypeError(typeof iterable + " is not iterable");
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $b48770f827831fc3$exports));
try {
    regeneratorRuntime = $b48770f827831fc3$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $b48770f827831fc3$var$runtime;
    else Function("r", "regeneratorRuntime = r")($b48770f827831fc3$var$runtime);
}


// eslint-disable-next-line @atlassian/ssr-linting/no-dom-globals-in-module-scope
if (!window.ResizeObserver) window.ResizeObserver = (0, $860d6ac538e2d2af$export$9caf76241ca21a11);


//# sourceMappingURL=babel.polyfills.b3858db4.js.map
